module.exports = __webpack_public_path__ + "static/dibuixllibre-capcalera-7e5c6303255ff155bcd5cb53568e5b0e.png";